import React from 'react';
import { usePdfBlobUrl } from 'src/design/molecules/usePdfBlobUrl';
import { triggerDownload } from 'src/utils';

export interface IPdfFile {
  data?: Blob;
  /** The server-chosen download name (FileResponse.fileName, from Content-Disposition). */
  fileName?: string;
}

export interface IPdfFileHandle {
  /** Object URL for <PdfViewer src>; null until the file has bytes. */
  url: string | null;
  /** Saves the file under its server-chosen name; does nothing until `url` is set. */
  download: () => void;
}

const FALLBACK_FILE_NAME = 'document.pdf';

/** @registry Turns a fetched PDF (FileResponse from a query) into a <PdfViewer> URL plus a download() that saves it under the server's file name. */
export const usePdfFile = (
  file: IPdfFile | null | undefined,
): IPdfFileHandle => {
  const url = usePdfBlobUrl(file?.data);
  const fileName = file?.fileName;

  const download = React.useCallback(() => {
    if (!url) return;
    triggerDownload(url, fileName || FALLBACK_FILE_NAME);
  }, [url, fileName]);

  return { url, download };
};
